import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Topics from "./components/Topics";
import Columns from "./components/Columns";
import Features from "./components/Features";
import Guide from "./components/Guide";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Topics />
        <Columns />
        <Features />
        <Guide />
        <Reviews />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}